export default {
  payments: "Payments",
  checkout: "Checkout",

  first_choose_project: "You have not created a project yet.",
  no_non_trial_project: "You have no non-trial project. Please create one to be able to subscribe.",
  project_is_trial: "This project is trial. Please switch to a non-trial project to subscribe.",
  payment_canceled: "Your payment is canceled!",
  payment_successfully: "Your payment was successful! Your project has been subscribed to the selected plan.",
  your_project_subscribed: "Your project has been successfully subscribed.",
  project_subscription_status: "Subscription Status: subscribed until {date}",
};
